import "bootstrap/dist/css/bootstrap.min.css";
// eslint-disable-next-line
import Popper from "popper.js";
import "bootstrap/dist/js/bootstrap.bundle.min";
import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App/App";
import * as serviceWorker from "./serviceWorker";
import { AppError } from "./components/App/AppError";
import { BrowserRouter } from "react-router-dom";

ReactDOM.render(
    <BrowserRouter>
    {/*<React.StrictMode>*/}
        <AppError>
            
            <App />
           
        </AppError>
    {/*</React.StrictMode>*/}
    </BrowserRouter>,
    document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
